import type { CertificateType, CreateCertificateRequest } from '$lib/api/types';

export type CertificateFormValues = {
	type: CertificateType;
	purpose: string;
	language: 'KO' | 'EN';
	sealRequired: boolean;
	approvalLineId: number;
};

export type CertificateFormValidation =
	| { ok: true; request: CreateCertificateRequest }
	| { ok: false; message: string };

const certificateTypes = new Set<CertificateType>(['EMPLOYMENT', 'CAREER']);

export function validateCertificateForm(values: CertificateFormValues): CertificateFormValidation {
	if (!certificateTypes.has(values.type)) {
		return { ok: false, message: '증명서 종류를 선택해주세요.' };
	}

	const purpose = values.purpose.trim();
	if (purpose.length > 500) {
		return { ok: false, message: '용도는 500자 이하로 입력해주세요.' };
	}

	if (values.language !== 'KO' && values.language !== 'EN') {
		return { ok: false, message: '증명서 언어를 선택해주세요.' };
	}

	if (!Number.isInteger(values.approvalLineId) || values.approvalLineId <= 0) {
		return { ok: false, message: '결재선을 선택해주세요.' };
	}

	return {
		ok: true,
		request: {
			type: values.type,
			...(purpose ? { purpose } : {}),
			language: values.language,
			sealRequired: values.sealRequired,
			approvalLineId: values.approvalLineId
		}
	};
}
